import React from 'react';
import classNames from 'classnames/bind';
import styles from './Dot.css';
var cx = classNames.bind(styles);
export var Dot = function Dot(_ref) {
  var type = _ref.type,
      duration = _ref.duration,
      autoplay = _ref.autoplay,
      classes = _ref.classes,
      onClick = _ref.onClick,
      view = _ref.view;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('root', "view_".concat(view), "type_".concat(type), classes === null || classes === void 0 ? void 0 : classes.root),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('fill', {
      fill_animate: autoplay
    }, classes === null || classes === void 0 ? void 0 : classes.fill),
    style: {
      animationDuration: "".concat(duration, "ms")
    }
  }));
};